import React, { useState } from "react";
import { Card, Row, Col, Button, Form } from "react-bootstrap";
import ReportesCorresponsaliasService from "../../../../Services/Reportes/ReportesCorresponsalias.Service";
import { CellIcon } from "../../../Utils/CellIcon/CellIcon";
import { DTOBuscarEmbarques } from "../../../../DTO/Reportes/Embarques/DTOBuscarEmbarques";
import { FaDownload } from "react-icons/fa";
import DataTable from "react-data-table-component";

export const BuscarEmbarques: React.FC = () => {
    const gridRef = React.useRef<any>(null)
    const [Busqueda, setBusqueda] = useState<string>('');
    const [Embarques, setEmbarques] = useState<DTOBuscarEmbarques[]>([]);
    const [columnDefs] = useState([
        {headerName: 'id', selector:(row: DTOBuscarEmbarques) => row.id, sortable: true},
        {headerName: 'ADUANA', selector:(row: DTOBuscarEmbarques) => row.aduana, sortable: true},
        {headerName: 'TIPO DE EMBARQUE', selector:(row: DTOBuscarEmbarques) => row.tipoEmbarque, sortable: true},
        {headerName: 'DESTINO', selector:(row: DTOBuscarEmbarques) => row.destino, sortable: true},
        {headerName: 'DIAS EN ADUANA', selector:(row: DTOBuscarEmbarques) => row.diasEnAduana, sortable: true},
        {headerName: 'NOMBRE', selector:(row: DTOBuscarEmbarques) => row.nombre, sortable: true},
        {headerName: 'NO DE PEDIMENTO', selector:(row: DTOBuscarEmbarques) => row.noPedimento, sortable: true},
        {headerName: 'TIPO', selector:(row: DTOBuscarEmbarques) => row.tipo, sortable: true},
        {headerName: 'ORDEN DE COMPRA', selector:(row: DTOBuscarEmbarques) => row.ordenCompra, sortable: true},
        {headerName: 'FACTURA', selector:(row: DTOBuscarEmbarques) => row.factura, sortable: true},
        {headerName: 'PROVEEDOR', selector:(row: DTOBuscarEmbarques) => row.proveedor, sortable: true},
        {headerName: 'DESCRIPCION', selector:(row: DTOBuscarEmbarques) => row.descripcionMercancia, sortable: true},
        {headerName: 'BULTOS', selector:(row: DTOBuscarEmbarques) => row.bultos, sortable: true},
        {headerName: 'CANTIDAD DE CONTENEDORES', selector:(row: DTOBuscarEmbarques) => row.cantidadContenedores, sortable: true},
        {headerName: 'PESO NETO', selector:(row: DTOBuscarEmbarques) => row.pesoNeto, sortable: true},
        {headerName: 'INCOTERM', selector:(row: DTOBuscarEmbarques) => row.incoterm, sortable: true},
        {headerName: 'FECHA ETA', selector:(row: DTOBuscarEmbarques) => row.fechaETA.toDateString(), sortable: true},
        {headerName: 'ESTATUS', selector:(row: DTOBuscarEmbarques) => row.estatus, sortable: true},
        {headerName: 'OBSERVACIONES', selector:(row: DTOBuscarEmbarques) => row.observaciones, sortable: true},
        {headerName: 'FECHA DE INICIO DE GASTOS DE ALMACENAJE', selector:(row: DTOBuscarEmbarques) => row.fechaInicioGastosAlmacenaje.toDateString(), sortable: true},
        {headerName: 'COSTO DIARIO ALMACENAJE', cellRenderer: (params: any) => {return `$ ${params.data.costoDiarioAlmacenaje}`}},
        {headerName: 'COSTO DIARIO CONEXION', cellRenderer: (params: any) => {return `$ ${params.data.costoDiarioConexion}`}},
        {headerName: 'TOTAL A PAGAR ALMACENAJE', cellRenderer: (params: any) => {return `$ ${params.data.totalPagar}`}},
        {headerName: 'TOTAL PAGAR CONEXION', cellRenderer: (params: any) => {return `$ ${params.data.totalPagarConexion}`}},
        {headerName: 'FECHA DE DESPACHO', selector:(row: DTOBuscarEmbarques) => row.fechaDespacho.toDateString(), sortable: true},
        {headerName: 'NOMBRE DE PAQUETERIA O TRANSPORTISTA', selector:(row: DTOBuscarEmbarques) => row.nombrePaqueteria, sortable: true},
        {headerName: 'NO. DE GUIA DE EMBARQUE A DESTINO', selector:(row: DTOBuscarEmbarques) => row.noGuiaEmbarqueDestino, sortable: true},
        {headerName: 'FECHA DE ENTREGA EN DESTINO FINAL', selector:(row: DTOBuscarEmbarques) => row.fechaEntregaDestinoFinal.toDateString(), sortable: true},
        {headerName: 'FACTURA', cellRenderer: (params: any) => {
            return <CellIcon hasFile={params.data.facturaCorresponsal} idTrafico={params.data.id} proceso={16} ></CellIcon>
        }},
        {headerName: 'CERTIFICADO DE CALIDAD',  cellRenderer: (params: any) => {
            return <CellIcon hasFile={params.data.certificadoCalidad} idTrafico={params.data.id} proceso={15} ></CellIcon>
        }},
        {headerName: 'PACKING LIST',  cellRenderer: (params: any) => {
            return <CellIcon hasFile={params.data.packingList} idTrafico={params.data.id} proceso={18} ></CellIcon>
        }},
        {headerName: 'HOJA TECNICA',  cellRenderer: (params: any) => {
            return <CellIcon hasFile={params.data.hojaTecnica} idTrafico={params.data.id} proceso={17} ></CellIcon>
        }},
        {headerName: 'BL',  cellRenderer: (params: any) => {
            return <CellIcon hasFile={params.data.bl} idTrafico={params.data.id} proceso={14} ></CellIcon>
        }},
        {headerName: 'PEDIMENTO INFORMATIVO',  cellRenderer: (params: any) => {
            return <CellIcon hasFile={params.data.pedimentoInformativo} idTrafico={params.data.id} proceso={12} ></CellIcon>
        }, width: '130'},
        {headerName: 'PEDIMENTO SIMPLIFICADO',  cellRenderer: (params: any) => {
            return <CellIcon hasFile={params.data.pedimentoSimplificado} idTrafico={params.data.id} proceso={13} ></CellIcon>
        }, width: '130'},
        {headerName: 'DODA',  cellRenderer: (params: any) => {
            return <CellIcon hasFile={params.data.doda} idTrafico={params.data.id} proceso={11} ></CellIcon>
        }, width: '130'},
        {headerName: 'HONORARIOS AA',  cellRenderer: (params: any) => {
            return <CellIcon hasFile={params.data.honorarios} idTrafico={params.data.id} proceso={37} ></CellIcon>
        }, width: '130'},
        {headerName: 'TOTAL HONORARIOS AA', cellRenderer: (params: any) => {return `$ ${params.data.totalHonorarios}`}},
        {headerName: 'GASTOS A TERCEROS', cellRenderer: (params: any) => {
            return <CellIcon hasFile={params.data.gastosTerceros} idTrafico={params.data.id} proceso={41} ></CellIcon>
        }, width: '130'},
        {headerName: 'TOTAL GASTOS A TERCEROS', cellRenderer: (params: any) => {return `$ ${params.data.totalGastosTerceros}`}, sortable: true},
        {headerName: 'COMPROBANTES GASTOS A TERCEROS',selector:(row: DTOBuscarEmbarques) => row.comprobantesGastosTerceros, sortable: true},
    ]);

    const filtraEmbarques = (e: any) => {
        gridRef.current.api.setQuickFilter(e.target.value)
    }

    const buscarEmbarques = () => {
        if(Busqueda !== '' && Busqueda !== null && Busqueda !== undefined){
            ReportesCorresponsaliasService.BuscarEmbarques(Busqueda)
            .then((response) => {
                setEmbarques(response.data);
            });
        }else{
            //Mostrar mensaje de error
        }
    }

    const exportarEmbarques = () => {
        ReportesCorresponsaliasService.GetExcelBuscados(Busqueda)
        .then(resp => {
            const url = window.URL.createObjectURL(new Blob([resp.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `ReporteBusquedaDeEmbarques.xlsx`);
            document.body.appendChild(link);
            link.click();
        })
    }

    return (
        <>
        <Card>
            <Card.Body>
            <Row className="mb-2">
                    <Col xs={5}>
                        <Form.Control
                            value={Busqueda}
                            type='text'
                            size='sm'
                            placeholder='Search...'
                            onChange={(e) => {
                                setBusqueda(e.target.value)
                            }}
                        />
                    </Col>
                    <Col>
                        <Button className="me-2" variant="primary" onClick={buscarEmbarques}>Generar</Button>
                        { Embarques.length > 0 ? <Button onClick={exportarEmbarques}><FaDownload/>&nbsp;Excel</Button> : "" }
                    </Col>
                </Row>
            </Card.Body>
        </Card>
        <Card className='mt-2' style={{visibility: Embarques.length > 0 ? "visible" : "hidden"}}>
            <Card.Body>  
                <Row className="mb-2">
                    <Col xs={5}>
                        <Form.Control
                            type='text'
                            size='sm'
                            placeholder='Search...'
                            onChange={(e) => {
                            filtraEmbarques(e)
                            }}
                        />
                    </Col>
                </Row>
                <div className='pt-2'>
                    <Col xs={12}>
                    <DataTable
                        noHeader
                        defaultSortFieldId={'id'}
                        defaultSortAsc={true}
                        pagination
                        paginationPerPage={15}
                        striped={true}
                        dense={true}
                        highlightOnHover
                        columns={columnDefs}
                        data={Embarques}
                        /* expandableRows={Perfil === "Administrador" || Perfil === "GEMCO"}
                        expandableRowsComponent={({data}) => {
                            return (
                            <RptFacturasDetail idHeader={data.id} showMsg={
                                (type:string, message: string) => {
                                    showToastMessage(type, message)
                                }
                                }
                            />
                            )
                        }} */
                    />
                    </Col>
                </div>
            </Card.Body>
        </Card>
        </>
    );
}